import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { Container, Switch, Label } from './styles/index.style';
import { Slider } from '@material-ui/core';

const Toggle = ({
    background,
    labelTrue,
    labelFalse,
    onChange,
    value,
    disabled,
    isAutomation,
    isLoading
}) => {
    const [isToggled, setIsToggled] = useState(value || false);
    const [showModal, setShowModal] = useState(false);
    const [pendingValue, setPendingValue] = useState(null);
    const [fieldValue, setFieldValue] = useState(100);

    useEffect(() => {
        setIsToggled(value);
    }, [value]);

    const handleToggle = () => {
        if (disabled) return;
        setPendingValue(!isToggled);
        setShowModal(true);
    };

    const confirmToggle = () => {
        const newValue = pendingValue;
        setIsToggled(newValue);

        if (onChange) {
            if (isAutomation) {
                onChange({
                    toggled: newValue,
                    setpoint: fieldValue
                });
            } else {
                onChange(newValue);
            }
        }

        setShowModal(false);
        setPendingValue(null);
    };

    const cancelToggle = () => {
        if (isLoading) return;
        setShowModal(false);
        setPendingValue(null);
    };

    return (
        <>
            <Container isToggled={isToggled} background={background} onClick={handleToggle}>
                <Label>{isToggled ? labelTrue : labelFalse}</Label>
                <Switch background={background} isToggled={isToggled} />
            </Container>

            <Modal show={showModal} onHide={cancelToggle} centered>
                <Modal.Header closeButton={!isLoading}>
                    <Modal.Title>Confirmar Ação</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Tem certeza que deseja enviar o comando?
                    {isAutomation && !isToggled && (
                        <div>
                            <p>Defina o setpoint</p>
                            <div style={{ marginTop: 50 }}>
                                <Slider
                                    step={1}
                                    min={100}
                                    max={250}
                                    value={fieldValue}
                                    valueLabelDisplay="on"
                                    marks={[
                                        { value: 100, label: '100' },
                                        { value: 150, label: '150' },
                                        { value: 200, label: '200' },
                                        { value: 250, label: '250' }
                                    ]}
                                    onChange={(e, value) => setFieldValue(value)}
                                    disabled={isLoading}
                                />
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={cancelToggle} disabled={isLoading}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={confirmToggle} disabled={isLoading}>
                        {isLoading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                /> Enviando...
                            </>
                        ) : (
                            'Confirmar'
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Toggle;